import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerURLService } from './serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class IpServiceService {

  constructor(private http:HttpClient, public serverURL: ServerURLService) { }  

  public getIPAddress() {  
    if(this.serverURL?.apiAddress?.includes('portal.dciindia.gov.in')) {
      return this.http.get("https://api.ipify.org/?format=json");  
    } else {
      return this.http.get("http://api.ipify.org/?format=json");  
    }
  }  
  
}
